module.exports = __webpack_public_path__ + "static/img/jc_zt_sec4_img1.3917f7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/jc_zt_sec4_img1.jpg
// module id = 9GH3
// module chunks = 171